export default class ProfileViewModel {
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public role: string = '';
    public roleId: string = '';
}